const isProductSKUActive = (selected?: boolean, inventory?: number) => Boolean(selected) && Boolean(inventory);

export default isProductSKUActive;
